module.exports = __webpack_public_path__ + "img/safety-tool-fta-item1-1.4ddfca82.png";